<template>
    <div class="mix-line-container">
        <div id="mix-line-container" class="mix-line-container"></div>
    </div>
</template>

<script>
  export default {

    data() {
      return {
        myChart: null,
        flowData: [
          { name: 'text', value: 21 },
          { name: 'text', value: 23 },
          { name: 'text', value: 25 },
          { name: 'text', value: 22 },
          { name: 'text', value: 23 },
          { name: 'text', value: 21 },
          { name: 'text', value: 25 }
        ],
        flowData1: [
          { label: 'text', value: 34 },
          { label: 'text', value: 31 },
          { label: 'text', value: 35 },
          { label: 'text', value: 32 },
          { label: 'text', value: 35 },
          { label: 'text', value: 37 },
          { label: 'text', value: 34 }
        ]
      }
    },
    mounted() {
      // 预防溢出
      setTimeout(() => {
        this.drawLine()
      }, 10)
    },
    destroyed() {
      this.myChart.dispose()
    },
    methods: {
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        this.myChart = this.$echarts.init(document.getElementById('mix-line-container'))
        // 绘制图表
        this.myChart.setOption({
          legend: {
            data: [
              { name: '爬取数量', icon: 'circle' },
              { name: '解析数量', icon: 'circle' }
            ]
          },
          grid: {
            right: '1%',
            top: '13%',
            left: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#E2E2E2',
                width: 2
              }
            },
            axisTick: { show: false },
            axisLabel: { color: '#666666', margin: 20 },
            splitLine: { color: '#EBEBEB', width: 1 },
            data: this.flowData.map(item => item.name)
          },
          yAxis: {
            type: 'value',
            axisLine: { show: false },
            axisLabel: { margin: 20 },
            axisTick: { show: false }
          },

          series: [
            {
              name: '爬取数量',
              type: 'line',
              smooth: 0.4,
              symbol: 'none',
              itemStyle: { color: '#4683FF' },
              lineStyle: {width: 3 },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,       //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
                  [
                    { offset: 0, color: '#4683FF' },
                    { offset: 1, color: '#fff' }
                  ]
                )
              },
              data: this.flowData.map(item => item.value)
            },
            {
              name: '解析数量',
              type: 'line',
              smooth: 0.4,
              symbol: 'none',
              itemStyle: { color: '#3DD598'},
              lineStyle: {width: 3 },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,       //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
                  [
                    { offset: 0, color: '#3DD598' },
                    { offset: 1, color: '#fff' }
                  ]
                )
              },
              data: this.flowData1.map(item => item.value)
            }
          ]
        })

        window.addEventListener('resize', () => {
          this.myChart.resize()
        })
      }
    },
    watch: {
      flowData() {
        this.drawLine()
      }
    }
  }
</script>

<style scoped lang="less">
    .mix-line-container {
        background: white;
        width: 100%;
        height: 370px;

        .flow-line {
            width: 100%;
            height: 100%;
        }
    }
</style>
